

import { interpolateSafe, PhraseMap } from '@ms/yammer-i18n';

export default class InterpolateStrings {

  public static feature: string = 'teams';

  private locale: string;
  private phrases: PhraseMap;

  constructor(locale: string, phrases: PhraseMap) {
    this.locale = locale;
    this.phrases = phrases;
  }

  public manifestNameShort(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNameShort');
  }

  public manifestDescriptionShort(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestDescriptionShort');
  }

  public manifestDescriptionShortVE(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestDescriptionShortVE');
  }

  public manifestDescriptionFull(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestDescriptionFull');
  }

  public manifestDescriptionFullVE(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestDescriptionFullVE');
  }

  public manifestVivaEngageNameShort(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestVivaEngageNameShort');
  }

  public manifestVivaEngageDescriptionShort(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestVivaEngageDescriptionShort');
  }

  public manifestVivaEngageDescriptionFull(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestVivaEngageDescriptionFull');
  }

  public manifestAnnouncementCreatedActivityDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAnnouncementCreatedActivityDescription');
  }

  public manifestAnnouncementCreatedActivityComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAnnouncementCreatedActivityComingSoonDescription');
  }

  public manifestAnnouncementCreatedActivityTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAnnouncementCreatedActivityTemplateText', args);
  }

  public manifestAtMentionActivityDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAtMentionActivityDescription');
  }

  public manifestAtMentionActivityComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAtMentionActivityComingSoonDescription');
  }

  public manifestAtMentionActivityTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAtMentionActivityTemplateText', args);
  }

  public manifestAboutCommunitiesAppBotCommandTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAboutCommunitiesAppBotCommandTitle');
  }

  public manifestAboutCommunitiesAppBotCommandDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAboutCommunitiesAppBotCommandDescription');
  }

  public manifestUserSignOutLinkPreviewBotCommandTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestUserSignOutLinkPreviewBotCommandTitle');
  }

  public manifestUserSignOutLinkPreviewBotCommandDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestUserSignOutLinkPreviewBotCommandDescription');
  }

  public manifestDirectFollowerActivityDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestDirectFollowerActivityDescription');
  }

  public manifestDirectFollowerActivityDescriptionComingSoon(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestDirectFollowerActivityDescriptionComingSoon');
  }

  public manifestDirectFollowerTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestDirectFollowerTemplateText', args);
  }

  public manifestUserAddedToCommunityActivityDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestUserAddedToCommunityActivityDescription');
  }

  public manifestUserAddedToCommunityActivityTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestUserAddedToCommunityActivityTemplateText', args);
  }

  public manifestUserSharedStoryActivityDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestUserSharedStoryActivityDescription');
  }

  public manifestUserSharedStoryActivityComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestUserSharedStoryActivityComingSoonDescription');
  }

  public manifestUserSharedStoryActivityTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestUserSharedStoryActivityTemplateText', args);
  }

  public manifestStorylineDigestActivityDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestStorylineDigestActivityDescription');
  }

  public manifestStorylineDigestActivityComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestStorylineDigestActivityComingSoonDescription');
  }

  public manifestStorylineDigestActivityTemplateText(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestStorylineDigestActivityTemplateText');
  }

  public manifestNewAnswerInYourQuestionDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAnswerInYourQuestionDescription');
  }

  public manifestNewAnswerInYourQuestionComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAnswerInYourQuestionComingSoonDescription');
  }

  public manifestNewAnswerInYourQuestionTemplateText(args: { actor: string|number; answer_count: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAnswerInYourQuestionTemplateText', args);
  }

  public manifestNewAnswerInFollowedQuestionDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAnswerInFollowedQuestionDescription');
  }

  public manifestNewAnswerInFollowedQuestionComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAnswerInFollowedQuestionComingSoonDescription');
  }

  public manifestNewAnswerInFollowedQuestionTemplateText(args: { actor: string|number; answer_count: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAnswerInFollowedQuestionTemplateText', args);
  }

  public manifestYourAnswerMarkedBestDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestYourAnswerMarkedBestDescription');
  }

  public manifestYourAnswerMarkedBestComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestYourAnswerMarkedBestComingSoonDescription');
  }

  public manifestYourAnswerMarkedBestTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestYourAnswerMarkedBestTemplateText', args);
  }

  public manifestBestAnswerOnFollowedQuestionDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestBestAnswerOnFollowedQuestionDescription');
  }

  public manifestBestAnswerOnFollowedQuestionComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestBestAnswerOnFollowedQuestionComingSoonDescription');
  }

  public manifestBestAnswerOnFollowedQuestionTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestBestAnswerOnFollowedQuestionTemplateText', args);
  }

  public manifestVoteOnYourQuestionDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestVoteOnYourQuestionDescription');
  }

  public manifestVoteOnYourQuestionComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestVoteOnYourQuestionComingSoonDescription');
  }

  public manifestVoteOnYourQuestionTemplateText(args: { vote_count: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestVoteOnYourQuestionTemplateText', args);
  }

  public manifestYourAnswerVotedDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestYourAnswerVotedDescription');
  }

  public manifestYourAnswerVotedComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestYourAnswerVotedComingSoonDescription');
  }

  public manifestYourAnswerVotedTemplateText(args: { actor: string|number; vote_count: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestYourAnswerVotedTemplateText', args);
  }

  public manifestLeadershipAnnouncementDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestLeadershipAnnouncementDescription');
  }

  public manifestLeadershipAnnouncementTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestLeadershipAnnouncementTemplateText', args);
  }

  public manifestCampaignLiveAnnouncementDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestCampaignLiveAnnouncementDescription');
  }

  public manifestCampaignLiveAnnouncementTemplateText(args: { campaign_name: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestCampaignLiveAnnouncementTemplateText', args);
  }

  public manifestNewAwardedAchievementTemplateText(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAwardedAchievementTemplateText');
  }

  public manifestNewAwardedAchievementDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAwardedAchievementDescription');
  }

  public manifestNewAwardedAchievementComingSoonDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAwardedAchievementComingSoonDescription');
  }

  public manifestNewQuestionInAskMeAnythingTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewQuestionInAskMeAnythingTemplateText', args);
  }

  public manifestNewQuestionInAskMeAnythingDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewQuestionInAskMeAnythingDescription');
  }

  public manifestNewReplyInAskMeAnythingQuestionTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewReplyInAskMeAnythingQuestionTemplateText', args);
  }

  public manifestNewReplyInAskMeAnythingQuestionDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewReplyInAskMeAnythingQuestionDescription');
  }

  public manifestOrganizerUpcomingAskMeAnythingTemplateText(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestOrganizerUpcomingAskMeAnythingTemplateText');
  }

  public manifestOrganizerUpcomingAskMeAnythingDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestOrganizerUpcomingAskMeAnythingDescription');
  }

  public manifestNewReplyInYourVotedAMAQuestionTemplateText(args: { actor: string|number }): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewReplyInYourVotedAMAQuestionTemplateText', args);
  }

  public manifestNewReplyInYourVotedAMAQuestionDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewReplyInYourVotedAMAQuestionDescription');
  }

  public manifestNewAnonymousQuestionInAMATemplateText(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAnonymousQuestionInAMATemplateText');
  }

  public manifestNewAnonymousQuestionInAMADescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestNewAnonymousQuestionInAMADescription');
  }

  public manifestAnonymousUserMentionInAMATemplateText(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAnonymousUserMentionInAMATemplateText');
  }

  public manifestAnonymousUserMentionInAMADescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'manifestAnonymousUserMentionInAMADescription');
  }

  public vivaEngageAppSearchAutocompleteSeeMoreLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchAutocompleteSeeMoreLabel');
  }

  public vivaEngageAppSearchAutocompleteGroupsLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchAutocompleteGroupsLabel');
  }

  public vivaEngageAppSearchAutocompleteUsersLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchAutocompleteUsersLabel');
  }

  public vivaEngageAppSearchAutocompleteNoResults(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchAutocompleteNoResults');
  }

  public vivaEngageAppSearchAutocompleteLoading(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchAutocompleteLoading');
  }

  public vivaEngageAppSearchBoxAllVivaEngage(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchBoxAllVivaEngage');
  }

  public vivaEngageAppSearchBoxSearchVivaEngagePlaceholder(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchBoxSearchVivaEngagePlaceholder');
  }

  public vivaEngageAppSearchBoxCloseSearchAriaLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchBoxCloseSearchAriaLabel');
  }

  public vivaEngageAppSearchBoxSearchVivaEngageAnswersPlaceholder(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageAppSearchBoxSearchVivaEngageAnswersPlaceholder');
  }

  public vivaEngageCollapsiblePanelCollapseButtonAriaLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageCollapsiblePanelCollapseButtonAriaLabel');
  }

  public vivaEngageCollapsiblePanelCollapseConfirmationText(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageCollapsiblePanelCollapseConfirmationText');
  }

  public vivaEngageCollapsiblePanelExpandButtonAriaLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageCollapsiblePanelExpandButtonAriaLabel');
  }

  public vivaEngageCollapsiblePanelExpandConfirmationText(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageCollapsiblePanelExpandConfirmationText');
  }

  public vivaEngageCollapsiblePanelScreenReaderHeadingText(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageCollapsiblePanelScreenReaderHeadingText');
  }

  public vivaEngageCollapsiblePanelFooterMyBookmarksButton(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageCollapsiblePanelFooterMyBookmarksButton');
  }

  public vivaEngageCollapsiblePanelFooterMyDraftsButton(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageCollapsiblePanelFooterMyDraftsButton');
  }

  public vivaEngageCollapsiblePanelFooterMyAnalyticsButton(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageCollapsiblePanelFooterMyAnalyticsButton');
  }

  public vivaEngageFailedToLoadTryAgainButtonLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageFailedToLoadTryAgainButtonLabel');
  }

  public vivaEngageFailedToLoadPageTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageFailedToLoadPageTitle');
  }

  public vivaEngageFirstRunExperienceDialogTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageFirstRunExperienceDialogTitle');
  }

  public vivaEngageFirstRunExperienceDialogDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageFirstRunExperienceDialogDescription');
  }

  public vivaEngageFirstRunExperienceDialogAcknowledgeButtonLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageFirstRunExperienceDialogAcknowledgeButtonLabel');
  }

  public vivaEngageFirstRunExperienceInfoLinkLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageFirstRunExperienceInfoLinkLabel');
  }

  public vivaEngageUserProvisioningPendingTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageUserProvisioningPendingTitle');
  }

  public vivaEngageUserProvisioningPendingDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageUserProvisioningPendingDescription');
  }

  public vivaEngageUserProvisioningErrorTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageUserProvisioningErrorTitle');
  }

  public vivaEngageUserProvisioningErrorDescription(): string {
    return interpolateSafe(this.locale, this.phrases, 'vivaEngageUserProvisioningErrorDescription');
  }

}
